import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Button,
  
} from '@mui/material';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import { partyRecycle, partyRestore, } from "../../../Services/Services"; // Update with actual path
import Popover from '@mui/material/Popover';

const PartyRestore = () => {
    const [parties, setParties] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [partyToDelete, setPartyToDelete] = useState(null);


    useEffect(() => {
        const fetchParties = async () => {
            const data = await partyRecycle();
            setParties(data);
        };

        fetchParties();
    }, []);


    const handleDelete = async (party_id) => {
        try {
            const response = await partyRestore(party_id); // don't pass any argument if not needed
            setParties(response);
        } catch (error) {
            console.error("Error fetching branch:", error);
        }
    };



    return (
        <Box>

            {/* Table */}
            {parties.length === 0 ? (
                <Typography>No parties found.</Typography>
            ) : (
                <TableContainer id="printable-table" sx={{ overflowX: "auto", maxWidth: "100%" }}>
                    <Table size="small" sx={{ "& td, & th": { borderBottom: "1px solid #ccc" } }}>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: "#f5f5f5", "& th": { fontWeight: "bold", color: "#333", borderBottom: "1px solid #999", whiteSpace: "nowrap" } }}>
                                <TableCell align="center">S. No.</TableCell>

                                <TableCell align="center">Party Name</TableCell>
                                <TableCell align="center">Munsiyana</TableCell>
                                <TableCell align="center">Contact No</TableCell>
                                <TableCell align="center">Address</TableCell>
                                <TableCell align="center">GST No</TableCell>
                                <TableCell align="center">PAN No</TableCell>
                                <TableCell align="center" className="no-print">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {parties.map((party, index) => (
                                <TableRow key={party.partyId}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff", // alternate row color
                                        "& td": {
                                            paddingTop: "0px",
                                            paddingBottom: "0px",
                                            fontSize: "0.8125rem",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            maxWidth: 120,
                                            color: (theme) =>
                                                theme.palette.mode === "dark" ? "white" : "inherit",
                                            backgroundColor: (theme) =>
                                                theme.palette.mode === "dark" ? "black" : "inherit",
                                        },
                                    }}
                                >
                                    <TableCell align="center">{index + 1}</TableCell>

                                    <TableCell align="center">{party.name}</TableCell>
                                    <TableCell align="center">{party.commission}</TableCell>
                                    <TableCell align="center">{party.contact_no}</TableCell>
                                    <TableCell align="center">{party.address}</TableCell>
                                    <TableCell align="center">{party.gst_no}</TableCell>
                                    <TableCell align="center">{party.pan_no}</TableCell>
                                    <TableCell align="center" className="no-print">
                                      
                                        <IconButton
                                            onClick={(event) => {
                                                setAnchorEl(event.currentTarget);
                                                setPartyToDelete(party.party_id);
                                            }}
                                            color="error"
                                            size="small"
                                        >
                                           <RestoreFromTrashIcon fontSize="small" style={{color:"blue"}}/>
                                        </IconButton>

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

        

            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => {
                    setAnchorEl(null);
                    setPartyToDelete(null);
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Box sx={{ p: 1 }}>
                    <Typography variant="body2">Are you sure ?</Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                        <Button
                            color="error"
                            size="small"
                            onClick={async () => {
                                try {
                                    await handleDelete(partyToDelete);
                                } finally {
                                    setAnchorEl(null);
                                    setPartyToDelete(null);
                                }
                            }}
                        >
                            Yes
                        </Button>
                        <Button
                            size="small"
                            onClick={() => {
                                setAnchorEl(null);
                                setPartyToDelete(null);
                            }}
                        >
                            No
                        </Button>
                    </Box>
                </Box>
            </Popover>

        </Box>
    );
};

export default PartyRestore;
